import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "nerv-page-shell" }
const _hoisted_2 = {
  key: 0,
  class: "crt-boot"
}
const _hoisted_3 = {
  key: 1,
  class: "crt-sweep"
}
const _hoisted_4 = { class: "nerv-main" }
const _hoisted_5 = { class: "nerv-page-frame" }
const _hoisted_6 = { class: "nerv-footer" }
const _hoisted_7 = { class: "nerv-page-frame nerv-footer-inner" }
const _hoisted_8 = { class: "nerv-caption" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "nerv-caption" }, "Plano, Texas", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "nerv-status nerv-lcd" }, "System nominal", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NervReticle = _resolveComponent("NervReticle")!
  const _component_NervTopBar = _resolveComponent("NervTopBar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_NervTicker = _resolveComponent("NervTicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.booting)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.booting)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3))
      : _createCommentVNode("", true),
    _createVNode(_component_NervReticle),
    _createVNode(_component_NervTopBar),
    _createElementVNode("main", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createBlock(_component_router_view, {
          key: _ctx.$route.fullPath
        }))
      ])
    ]),
    _createElementVNode("footer", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, "© " + _toDisplayString(_ctx.year) + " Dev1 Consulting, LLC", 1),
        _hoisted_9,
        _createVNode(_component_NervTicker, { class: "footer-ticker" }),
        _hoisted_10
      ])
    ])
  ]))
}